const ESCALATION_MANAGER_EXTENSION = "Microsoft_EngOps_EscalationManager";
const RM2_CASE_DETAILS_VIEW = "EMCaseDetails.ReactView";
const isAzurePortalHost = (hostname) => hostname === "portal.azure.com" || hostname.endsWith(".portal.azure.com");
export const buildRm2CaseDetailsUrl = (configuredRm2PageLink, caseNumber) => {
    const normalizedCaseNumber = caseNumber.trim();
    const numericCaseNumber = Number(normalizedCaseNumber);
    if (!/^[1-9]\d*$/.test(normalizedCaseNumber) ||
        !Number.isSafeInteger(numericCaseNumber)) {
        return undefined;
    }
    try {
        const url = new URL(configuredRm2PageLink);
        const expectedHash = [
            "#view",
            ESCALATION_MANAGER_EXTENSION,
            RM2_CASE_DETAILS_VIEW,
            "caseNumber",
            normalizedCaseNumber,
        ].join("/");
        // A summary URL is not a case-route contract. Never manufacture a deep link.
        if (url.protocol !== "https:" ||
            !isAzurePortalHost(url.hostname) ||
            url.username ||
            url.password ||
            url.port ||
            url.pathname !== "/" ||
            url.hash !== expectedHash) {
            return undefined;
        }
        return url.toString();
    }
    catch (_a) {
        return undefined;
    }
};
